module.exports = __webpack_public_path__ + "static/media/boat-catamaran-hawaii-svgrepo-com.a71acc96.svg";